module.exports = __webpack_public_path__ + "lk.ae3b201ec9c215b6b74f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/lk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/lk.svg
// module chunks = styles